import * as React from 'react';

import { useLoaderData } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import { useMessage } from '../context/MessageProvider';

import Container from '@mui/material/Container';
import Grid from '@mui/material/Unstable_Grid2'; // Grid version 2
import Typography from '@mui/material/Typography';


import {useForm, FormProvider} from 'react-hook-form';
import Form from '../components/form/Form';
import FormDropDownAndUsed from '../components/form/FormDropDownAndUsed';
import FormButton from '../components/form/FormButton';

import Header from "../components/Header";
import Subtitle from "../components/Subtitle";
import GoBack from "../components/GoBack";

import { newSectionB, saveSectionB, listSectionBsByAssessment,listSectionBsThatStartedObservationRange } from '../models/sectionb';
import { listAnimals } from '../models/animals';
import { getFacility } from '../models/facility';
import { getAssessment, listAssessments } from '../models/assessments';

import {today, workdayTimeRanges} from "../utils/datetime";

import { useConnectivity } from '../context/ConnectivityProvider';

import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';

import { findModel } from '../utils/model';
import { isInProgress } from '../utils/assessments';

import { useSectionB } from '../context/SectionBProvider';

// if you need to load data, you can use this template, note that the return value needs to be an object with named records in it.
export async function loader({params}) {

    const assessments = await listAssessments();
    const assessment = await getAssessment(params.assessmentId);
    const sectionBs = await listSectionBsByAssessment(assessment.id);

    return {facility: await getFacility(), animals: await listAnimals(), assessments, assessment, sectionBs, newSectionB: newSectionB()};
}

export default function AssessmentSectionBSelectPage({title = "EWP",...props}) {

    const {setSuccess, setError} = useMessage();
    const {facility, animals, assessment, assessments, sectionBs } = useLoaderData(); 
    const navigate = useNavigate();
    const {isOnline} = useConnectivity();

    const {addObservation} = useSectionB();

    const [useClipboard,setUseClipboard] = React.useState(false)

    const [availableObservations,setAvailableObservations] = React.useState([]);
    const [extraObservations, setExtraObservations] = React.useState([]);

    const animal = findModel(animals,assessment.animal_id);
    if (animal === null) throw new Error("Could not locate the specified animal from the assessment");

    // generate observation ranges
    const days = ["Day 1","Day 2","Day 3"];
    const startOfDay = assessment?.start_of_day || facility?.start_of_day;
    const endOfDay = assessment?.end_of_day || facility?.end_of_day;
    const workdayRanges = (startOfDay && endOfDay) ? workdayTimeRanges(startOfDay, endOfDay) : [];

    const observationWindows = days.reduce((acc,day)=>{
        const temp = workdayRanges.map((cur)=>{
            return day + ": " + cur;
        });
        return acc.concat(temp);
    },[]);

    console.log(observationWindows);


    // if you're going to do a form submission, this is your starting point for the submit behavior
    const onSubmit = async (inputData) => {
        try {

            console.log("onSubmit inputData", inputData);


            const record = (sectionBs || []).find((cur)=>cur.id === inputData.id);
            if (record === null) {
                throw new Error("Could not locate a section record with id: " + inputData.id);
            }

            console.log('matched record', record);

            // set the observed_on value to the record

            const payload = {...record,observed_on: today()};
            console.log("payload: ", payload);
            const saveResult = await saveSectionB(payload,isOnline);
            console.log("sectionb save: ", saveResult);


            // if we're using the clipboard feature and we defined additional animals to start, we create each record and add to the clipboard system
            if (useClipboard && extraObservations.length > 0) {
                for (let i = 0; i < extraObservations.length; i++) {
                    const observationRecord = extraObservations[i];

                    // set the updated observed_on field

                    const data = {...observationRecord,observed_on: today()};
                    console.log("observationRecord data", data);
                    const saveResult = await saveSectionB(data, isOnline);
                    console.log(saveResult);

                    const localAssessment = findModel(assessments,observationRecord.assessment_id);
                    const asesessmentAnimal = findModel(animals,localAssessment?.animal_id);

                    addObservation({
                        id: observationRecord.id,
                        assessmentId: observationRecord.assessment_id,
                        title: asesessmentAnimal.name
                    });
                }
            }

            if (useClipboard) {
                addObservation({
                    id: inputData.id,
                    assessmentId: assessment.id,
                    title: assessment?.assessment_title || animal.name
                });
                setSuccess("Added section B observation(s) to clipboard");
                navigate("/assessments/");
            } else {
                setSuccess("Started Section B");
                navigate("/assessments/" + assessment.id + "/sectionb/" + inputData.id);
            }

        } catch (error) {
            console.error(error);
            setError(error.message);
        }
    }


    const sectionList = sectionBs.map((cur)=>{
        return {
            value: cur.id,
            label: cur.observation_range,
        };
    });

    const usedList = sectionBs.filter((cur)=>{
        return cur.submitted_on
    }).map((cur)=>cur.id);

    //console.log("sectionList", sectionList);
    //console.log("usedList:", usedList);

    const openAssessments = assessments.filter((cur)=>{
        return isInProgress(cur);
    });
    const openAssessmentIds = openAssessments.map((cur)=>cur.id);
    //console.log("open assessments: ", openAssessments, openAssessmentIds);

    const handleChange = async (data) => {
        try {

            console.log("change", data);

            if (data?.id) { // ensure we have an id

                const record = (sectionBs || []).find((cur)=>cur.id === data.id);
                if (record === null) {
                    throw new Error("Could not locate a section record with id: " + data.id);
                }
                //console.log('matched record', record);

                // get all the sectionBs with the same observation ranage
                const sectionBsWithRange = await listSectionBsThatStartedObservationRange(record.observation_range);
                //console.log("section Bs with range", sectionBsWithRange);

                // find ones that aren't submitted that aren't the current record
                const observableSectionBs = sectionBsWithRange.filter((cur)=>{
                    return cur.submitted_on === null && cur.id !== record.id;
                });
                //console.log("observable section bs with range",observableSectionBs);


                const availableObservableSectionBs = observableSectionBs.filter((cur)=>{
                    return cur.assessment_id !== assessment.id && openAssessmentIds.includes(cur.assessment_id);
                })

                //console.log('availableObservableSectionBs', availableObservableSectionBs);
                setAvailableObservations(availableObservableSectionBs);
            }

        } catch (error) {
            console.error(error);
            setError(error.message);
        }
    }

    const toggleExtraObservation = (localObservation) => {
        console.log("toggle",localObservation);

        if (extraObservations.includes(localObservation) === false) {
            setExtraObservations([...extraObservations,localObservation]);
        } else {
            setExtraObservations(extraObservations.filter((cur)=>cur.id !== localObservation.id));
        }
    }

    React.useEffect(()=>{
        console.log("extra Assessments", extraObservations);
    },[extraObservations]);

    const toggleClipboard = () => {
        setUseClipboard(!useClipboard);
    }


    const defaultValues = {...newSectionB()};
    const formProps = { defaultValues };
	const methods = useForm(formProps);


    // note you can play with the container maxwidth to spread out the window content appears in
    return (
        <Container component="main" maxWidth="sm">
            <GoBack onClick={()=>navigate(`/assessments/${assessment.id}`)} />
            <Header label={title} />
            <Subtitle>{assessment?.assessment_title || animal.name}</Subtitle>

            <FormProvider {...methods}>
                <Form onSubmit={methods.handleSubmit(onSubmit)} onChange={handleChange}>
                    <Grid container spacing={2}>
                        <Grid xs={12} sm={12} sx={{justifyContent: "center", alignItems: "center"}}> 
                            <FormDropDownAndUsed name="id" label="Observation Timeframe" list={sectionList} required usedList={usedList} />
                        </Grid>


                        <Grid xs={12} sm={12}> 
                            <FormGroup>
                                <FormControlLabel control={<Checkbox onClick={toggleClipboard} />} label="Add this observation to the clipboard" />
                            </FormGroup>
                        </Grid>

                        <Grid xs={12} sm={12} > 
                            <Typography>In addition for these animals, create observation at same timeframe and add to clipboard</Typography>
                            {availableObservations.map((observation)=>{
                                const localAssessment = openAssessments.find((cur)=>cur.id===observation.assessment_id);
                                if (localAssessment === null) throw new Error("Could not find assessment with id: " + observation.assessment_id);
                                const animal = findModel(animals,localAssessment.animal_id);

                                return(
                                    <Grid key={animal.id} xs={12}>
                                        <FormControlLabel disabled={!useClipboard} control={<Checkbox onClick={()=> { toggleExtraObservation(observation); }} />} label={animal.name} />
                                    </Grid>
                                );
                            })}

                        </Grid>

                        <Grid xs={12} sm={12}> 
                            <FormButton>Start</FormButton>
                        </Grid>

                    </Grid>

                </Form>
            </FormProvider>
        </Container>
    );
}
